import { render, staticRenderFns } from "./menuLateral.vue?vue&type=template&id=77c469da&scoped=true"
import script from "./menuLateral.vue?vue&type=script&lang=js"
export * from "./menuLateral.vue?vue&type=script&lang=js"
import style0 from "./menuLateral.vue?vue&type=style&index=0&id=77c469da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c469da",
  null
  
)

export default component.exports